import * as React from 'react';
import {isUndefined} from 'lodash';
import Modal from "../ui/Modal";

interface ActionsProps {
  schema: any;
  extRules: any;
  mode:string;
  progress: number;
  form_type: string;
  userRole: string;
  process_id: number;
  isVisible: boolean;
  status: number;
  readonly?: boolean;
  isPdf: boolean;
  user?: any;
  onSend: () => void;
  onPDF: () => void;
  onDraft: () => void;
  onDocument: (comment?: boolean, personal?: boolean, title?: string) => void;
  onRevoke: (comment?: boolean, personal?: boolean, title?: string) => void;
  onReturn: () => void;
  onDelete: () => void;
  onCopy: (lastComment?: string) => void;
  onLastComment: (lastComment?: string, lastCommentColor?: string) => void;
  onAddition: () => void;
}

interface ActionState{
  send: string;
  revoke: string;
  comment: any;
  visible: string[];
  lastComment?: string;
  lastCommentColor?: string;
  showOnLoad?: boolean;
  revokeColor?: string;
  initialModal: boolean;
}

class Actions extends React.Component<ActionsProps, ActionState>{
  constructor() {
    super();
  }

  componentWillMount() {
    this.setState({
      ...this.props.extRules?.ActionsDefaultState,
      initialModal: this.props.userRole === 'user' && this.props.status === 0
    })
  }

  render() {
    const { mode, user, status, readonly, onDocument } = this.props;
    const { comment, lastComment, lastCommentColor } = this.state;
    const blockStatusList = [6,8,10,12];

    return (
        <>
          <div className="reportbox-actions">
            <div className="note">
              {mode === 'suspended' && <span style={{color: 'red'}}>Приём заявок временно приостановлен</span> }
              {mode === 'working' && <span>Данные заявки сохраняются автоматически</span> }
            </div>

            {user.isAuth && (
                <div className="btn-content">
                  <button className="btn btn-backbutton btn-sm pull-right" onClick={this.props.onReturn}>
                    Назад к списку заявок
                  </button>

                  {lastComment && (
                      <button className="btn btn-sm pull-right btn-primary" onClick={this.props.onLastComment.bind(this, lastComment, lastCommentColor)} style={lastCommentColor ? { backgroundColor: lastCommentColor, borderColor: lastCommentColor } : {}}>
                        {lastComment}
                      </button>
                  )}

                  {
                    !blockStatusList.includes(status) && (
                          <button
                              className="btn btn-success btn-sm pull-right"
                              onClick={() => {
                                onDocument();
                              }}
                          >
                            Отправить
                          </button>
                    )}
                </div>
            )}
          </div>

          {/*<Modal show={this.state.initialModal} delay={500} onHide={this.closeModal} />*/}
        </>
    )
  }
}

export default Actions;
